import { myAxios } from "./axios";

export function getAllEducations(data, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(data || {}),
    },
  };
  return myAxios.get("/education", config);
}

export function getSingleEducation(id) {
  return myAxios.get("/education/" + id);
}

export function addEducation(data) {
  return myAxios.post("/education/create", data);
}

export function editEducation(id, data) {
  return myAxios.put("/education/" + id + "/update", data);
}

export function deleteEducation(id) {
  return myAxios.delete("/education/" + id + "/delete");
}
